var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"columns is-multiline"},_vm._l((_vm.resources),function(resource){return _c('resource-list-item',{key:resource.id,attrs:{"resource":resource}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }